import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-neutral-bg border-t border-neutral-border mt-auto">
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <div className="font-heading font-semibold text-neutral-text text-sm">
            Quantile Camp
          </div>
          <div className="text-xs text-neutral-text/50 font-body mt-1">
            Образовательная платформа для изучения SQL и ClickHouse
          </div>
          <div className="text-xs text-neutral-text/40 font-body mt-1">
            © 2024–{year} Quantile Camp. Все права защищены.
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          <Link
            to="/privacy"
            className="text-xs text-neutral-text/60 hover:text-primary transition-colors"
          >
            Политика конфиденциальности
          </Link>
          <span className="text-neutral-text/30 text-xs hidden sm:inline">·</span>
          <Link
            to="/terms"
            className="text-xs text-neutral-text/60 hover:text-primary transition-colors"
          >
            Условия использования
          </Link>
          <span className="text-neutral-text/30 text-xs hidden sm:inline">·</span>
          <Link
            to="/faq"
            className="text-xs text-neutral-text/60 hover:text-primary transition-colors"
          >
            FAQ
          </Link>
        </nav>
      </div>
    </footer>
  );
}
